import {
  BottomSheet,
  BottomSheetIllustrationContent,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";

interface ExtendShiftSuccessBottomSheetProps {
  modalState: UseModalState;
}

export function ExtendShiftSuccessBottomSheet(props: ExtendShiftSuccessBottomSheetProps) {
  const { modalState } = props;

  return (
    <BottomSheet modalState={modalState}>
      <BottomSheetIllustrationContent
        title="Shift extended"
        description={
          <Text semibold variant="body1" color={(theme) => theme.palette.text.secondary}>
            Additional time will be reviewed and paid separately by the workplace within 3 business
            days.
          </Text>
        }
        illustrationType="hours-limit"
      />
    </BottomSheet>
  );
}
